export const getStatusWarningMessage = (status, type = 'item') => {
    const messages = {
        pendingCreate: `This ${type} is pending approval and not yet visible to customers.`,
        pendingEdit: `Changes are pending approval. Customers can still see the live version of this ${type}.`,
        pendingDelete: `This ${type} is pending deletion and will be removed once approved.`,
        disabled: `This ${type} is disabled.`,
    };
    return messages[status] || `${type.charAt(0).toUpperCase() + type.slice(1)} status unknown.`;
};